export const WEBSOCKET_READY_STATE = {
	UNINSTANTIATED: -1,
	CONNECTING: 0,
	OPEN: 1,
	CLOSING: 2,
	CLOSED: 3,
};
